import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import {
  Menu,
  MenuItem,
  Toolbar,
  Button,
  AppBar,
  Typography,
} from "@mui/material";
import AccountSwitcher from "./AccountSwitcher";
import LanguageSwitcher from "./LanguageSwitcher";
import { Trans } from "react-i18next";
import pkg from "../../../package.json";
const { version } = pkg;

const styles = ({ layout, palette }) => ({
  appFrame: {
    zIndex: 1,
    position: "relative",
    display: "flex",
    width: "100%",
  },
  appBar: {
    width: `calc(100% - ${layout.drawerWidth}px)`,
    marginLeft: layout.drawerWidth,
    backgroundColor: palette.background.paper,
    color: palette.common.black,
  },
  flex: {
    flex: 1,
  },
});

class Header extends Component {
  state = {
    anchorEl: null,
  };

  handleMenuClick = (e) => this.setState({ anchorEl: e.currentTarget });

  handleMenuClose = () => this.setState({ anchorEl: null });

  render() {
    const { classes, username, logout, accessLevel } = this.props;
    const { anchorEl } = this.state;

    return (
      <AppBar position="absolute" className={classes.appBar}>
        <Toolbar>
          <div className={classes.flex}>
            {accessLevel === "admin" ? <AccountSwitcher /> : null}
          </div>
          <div>
            <LanguageSwitcher adminLevel={accessLevel === "admin"} />
            <Button
              color="inherit"
              onClick={this.handleMenuClick}
              style={{ marginLeft: "20px" }}
            >
              <Typography
                component="span"
                variant="inherit"
                style={{
                  fontWeight: "bold",
                  fontSize: ".9em",
                  display: "inline",
                }}
              >
                {username}
              </Typography>
              <ArrowDropDown />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleMenuClose}
            >
              <MenuItem>
                <Trans i18nKey="app_top_bar.app_version"></Trans>
                {version}
              </MenuItem>
              <MenuItem onClick={logout}>
                <Trans i18nKey="app_top_bar.logout"></Trans>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  username: PropTypes.string,
  accessLevel: PropTypes.oneOf(["admin", "superadmin"]).isRequired,
  logout: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(Header);
